import { env } from '../env/env';
export const tpfFundManagerConfig = {
    TPF_FUND_MANAGER_BASE_URL: env.getString('TPF_FUND_MANAGER_BASE_URL') || 'http://localhost:4242',
};
//# sourceMappingURL=tpfFundManagerConfig.js.map